import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "auto-complete-input-container" }
const _hoisted_2 = {
  key: 0,
  class: "suggestions-container"
}
const _hoisted_3 = { class: "suggestions-list" }
const _hoisted_4 = ["onMousedown"]

import { ref, watch, computed, onMounted } from 'vue';
import { Delete, Close } from '@element-plus/icons-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AutoCompleteInput',
  props: {
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  storageKey: {
    type: String,
    required: true
  },
  maxHistoryItems: {
    type: Number,
    default: 10
  }
},
  emits: ['update:modelValue'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const inputValue = ref(props.modelValue);
const suggestions = ref<string[]>([]);
const showSuggestions = ref(false);

// 监听modelValue变化
watch(() => props.modelValue, (newValue) => {
  inputValue.value = newValue;
});

// 监听inputValue变化
watch(() => inputValue.value, (newValue) => {
  emit('update:modelValue', newValue);
});

// 过滤建议列表
const filteredSuggestions = computed(() => {
  if (!inputValue.value) return suggestions.value;
  
  return suggestions.value.filter(suggestion => 
    suggestion.toLowerCase().includes(inputValue.value.toLowerCase())
  );
});

// 从LocalStorage加载建议
const loadSuggestionsFromStorage = () => {
  const storedSuggestions = localStorage.getItem(props.storageKey);
  if (storedSuggestions) {
    suggestions.value = JSON.parse(storedSuggestions);
  }
};

// 保存建议到LocalStorage
const saveSuggestionsToStorage = () => {
  localStorage.setItem(props.storageKey, JSON.stringify(suggestions.value));
};

// 添加新的建议到历史记录
const addSuggestion = (value: string) => {
  if (!value || value.trim() === '') return;
  
  // 移除已存在的相同值
  const index = suggestions.value.indexOf(value);
  if (index !== -1) {
    suggestions.value.splice(index, 1);
  }
  
  // 添加到列表前面
  suggestions.value.unshift(value);
  
  // 限制历史记录数量
  if (suggestions.value.length > props.maxHistoryItems) {
    suggestions.value = suggestions.value.slice(0, props.maxHistoryItems);
  }
  
  saveSuggestionsToStorage();
};

// 处理输入事件
const handleInput = () => {
  showSuggestions.value = true;
};

// 选择建议
const selectSuggestion = (suggestion: string) => {
  inputValue.value = suggestion;
  showSuggestions.value = false;
};

// 删除建议
const deleteSuggestion = (suggestion: string) => {
  const index = suggestions.value.indexOf(suggestion);
  if (index !== -1) {
    suggestions.value.splice(index, 1);
    saveSuggestionsToStorage();
  }
};

// 清空输入
const clearInput = () => {
  inputValue.value = '';
};

// 延迟隐藏建议，以便点击建议项和删除按钮
const hideSuggestionsDelayed = () => {
  setTimeout(() => {
    showSuggestions.value = false;
  }, 200);
};

// 提交输入值到历史记录
const submitValue = () => {
  if (inputValue.value) {
    addSuggestion(inputValue.value);
  }
};

// 暴露方法给父组件
__expose({
  submitValue
});

// 组件挂载时加载建议
onMounted(() => {
  loadSuggestionsFromStorage();
});

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_input, {
      modelValue: inputValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      placeholder: __props.placeholder,
      onInput: handleInput,
      onFocus: _cache[1] || (_cache[1] = ($event: any) => (showSuggestions.value = true)),
      onBlur: hideSuggestionsDelayed
    }, _createSlots({ _: 2 }, [
      (inputValue.value)
        ? {
            name: "suffix",
            fn: _withCtx(() => [
              _createVNode(_component_el_icon, { onClick: clearInput }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Close))
                ]),
                _: 1
              })
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue", "placeholder"]),
    (showSuggestions.value && filteredSuggestions.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("ul", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredSuggestions.value, (suggestion, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: index,
                class: "suggestion-item",
                onMousedown: ($event: any) => (selectSuggestion(suggestion))
              }, [
                _createElementVNode("span", null, _toDisplayString(suggestion), 1),
                _createVNode(_component_el_icon, {
                  class: "delete-icon",
                  onMousedown: _withModifiers(($event: any) => (deleteSuggestion(suggestion)), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Delete))
                  ]),
                  _: 2
                }, 1032, ["onMousedown"])
              ], 40, _hoisted_4))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})